<template>
  <!-- MBR072 discount code sheet — member_app_UI/song_fa_members_my_challenges_mobile -->
  <div
    class="modal modal-bottom fade"
    id="qrcode-discount-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="qrcode-discount-modal"
    style="z-index: 10000"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content mbr-discount">
        <div class="mbr-discount__top">
          <span class="mbr-discount__handle" aria-hidden="true"></span>
          <!-- keep .btn-close: views close every open sheet with $(".btn-close").click() -->
          <button
            type="button"
            class="btn-close mbr-discount__close"
            data-bs-dismiss="modal"
            :aria-label="$t('common.close')"
          >
            <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>

        <div class="mbr-discount__body">
          <h2 class="mbr-discount__title">{{ discountDetail.rule_name }}</h2>
          <span v-if="discountDetail.expiry_date_text" class="mbr-discount__expiry">
            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path stroke-linecap="round" d="M12 6v6l4 2" /></svg>
            <span>{{ $t('voucher.expiry', { date: discountDetail.expiry_date_text }) }}</span>
          </span>

          <section class="mbr-discount__card mbr-discount__card--code">
            <div v-if="isShowQr" class="mbr-discount__qr">
              <VueQRCodeComponent
                :text="discountDetail.rule_code"
                size="192"
                :color="qrColor"
                bg-color="#ffffff"
                error-level="L"
                class="d-flex justify-content-center"
              />
            </div>
            <span class="mbr-discount__caps">{{ $t('voucher.discount_code') }}</span>
            <div class="mbr-discount__code">
              <input
                ref="codeInput"
                type="text"
                class="js-copytextarea discount-code mbr-discount__code-value"
                :value="discountDetail.rule_code"
                readonly
              />
              <button
                type="button"
                class="mbr-discount__copy"
                :aria-label="copied ? $t('voucher.code_copied') : $t('voucher.copy_code')"
                @click="coppyDiscountCode()"
              >
                <svg v-if="copied" fill="none" stroke="currentColor" stroke-width="2.4" viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                <svg v-else fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
              </button>
            </div>
            <p class="mbr-discount__hint">
              {{ $t('voucher.show_code_hint') }}
            </p>
          </section>

          <section v-if="hasApplicability" class="mbr-discount__card">
            <h3 class="mbr-discount__heading">{{ $t('voucher.applicable_for') }}</h3>
            <div class="mbr-discount__rows">
              <div v-if="discountDetail.branch_can_exchange_text" class="mbr-discount__row">
                <span class="mbr-discount__icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                </span>
                <p>{{ discountDetail.branch_can_exchange_text }}</p>
              </div>
              <div v-if="discountDetail.item_apply_text" class="mbr-discount__row">
                <span class="mbr-discount__icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                </span>
                <p>{{ discountDetail.item_apply_text }}</p>
              </div>
              <div v-if="discountDetail.order_minimum_text" class="mbr-discount__row">
                <span class="mbr-discount__icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                </span>
                <p>{{ discountDetail.order_minimum_text }}</p>
              </div>
            </div>
          </section>

          <section v-if="terms.length > 0" class="mbr-discount__card">
            <h3 class="mbr-discount__heading">{{ $t('reward.terms_conditions') }}</h3>
            <ul class="mbr-discount__terms">
              <li v-for="(value, index) in terms" :key="index">{{ value }}</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
    <button
      class="btn-qrcode-discount-modal"
      style="display: none"
      data-bs-toggle="modal"
      data-bs-target="#qrcode-discount-modal"
    >
      Success
    </button>
  </div>
</template>

<script>
import VueQRCodeComponent from 'vue-qrcode-component'
import { themeTokenValue } from '@/config/themeColor'
export default {
  name: "QrcodeReward",
  components: {
    VueQRCodeComponent
  },
  props: {
    discountDetail: {
      type: Object,
      default() {
        return {
        }
      }
    },
    isShowQr: {
      type: Boolean,
      default() {
        return true
      }
    },
  },
  data() {
    return {
      copied: false,
      copiedTimer: null,
      qrColor: themeTokenValue('--mbr-color-qr', '#3A0F0F'),
    }
  },
  computed: {
    // the backend sends full sentences, one per rule; drop the card when none apply
    hasApplicability() {
      return Boolean(
        this.discountDetail.branch_can_exchange_text ||
        this.discountDetail.item_apply_text ||
        this.discountDetail.order_minimum_text
      )
    },

    terms() {
      return (this.discountDetail.terms_arr ?? []).filter(Boolean)
    },
  },
  beforeUnmount() {
    clearTimeout(this.copiedTimer)
  },
  methods: {
    coppyDiscountCode() {
      // via ref, not document: MyCampaigns mounts several sheets at once
      const ipnElement = this.$refs.codeInput
      if (!ipnElement) {
        return
      }
      ipnElement.select()
      document.execCommand('copy')
      this.copied = true
      clearTimeout(this.copiedTimer)
      this.copiedTimer = setTimeout(() => {
        this.copied = false
      }, 1500)
    }
  }
};
</script>
<style scoped>
/* MBR072 discount sheet — same shell as the voucher detail sheet (MBR035).
   Doubled with .modal.modal-bottom to outrank the square corners set below */
.modal.modal-bottom .modal-content.mbr-discount {
  max-height: 92vh;
  padding: 12px 20px 28px;
  overflow-y: auto;
  background: var(--mbr-color-canvas);
  border: 0;
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: 32px 32px 0 0;
  box-shadow: var(--mbr-shadow-modal);
  font-family: var(--mbr-font-body);
}

/* custom.css still carries the legacy `* { font-family: Poppins }` */
.mbr-discount :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-discount__top {
  position: relative;
  display: flex;
  justify-content: flex-end;
  min-height: 36px;
}

.mbr-discount__handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 40px;
  height: 4px;
  background: var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  transform: translateX(-50%);
}

/* reset Bootstrap's .btn-close (svg background, 1em box, 50% opacity) */
.mbr-discount__close.btn-close {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-tint) none;
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-secondary);
  opacity: 1;
  transition: transform 0.12s ease;
}

.mbr-discount__close.btn-close:active {
  transform: scale(0.95);
}

.mbr-discount__close.btn-close:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
  box-shadow: none;
}

.mbr-discount__close svg {
  width: 16px;
  height: 16px;
}

.mbr-discount__body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: stretch;
  padding-top: 4px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-discount__title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 24px;
  font-weight: 800;
  line-height: 30px;
  letter-spacing: -0.02em;
  color: var(--mbr-color-ink-headline);
}

.mbr-discount__expiry {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 6px;
  margin-top: -6px;
  padding: 4px 12px;
  background: var(--mbr-color-tint-dark);
  border-radius: var(--mbr-radius-full);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-discount__expiry svg {
  flex: none;
  width: 14px;
  height: 14px;
  color: var(--mbr-color-primary);
}

.mbr-discount__card {
  padding: 18px;
  background: var(--mbr-color-surface);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-xl);
  box-shadow: var(--mbr-shadow-card);
}

.mbr-discount__card--code {
  text-align: center;
}

.mbr-discount__qr {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.mbr-discount__caps {
  display: block;
  font-family: var(--mbr-font-headline);
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.1em;
  color: var(--mbr-color-ink-muted);
  text-transform: uppercase;
}

.mbr-discount__code {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 10px 10px 10px 14px;
  background: var(--mbr-color-canvas);
  border: 1px dashed rgba(var(--mbr-color-primary-rgb), 0.3);
  border-radius: var(--mbr-radius-md);
}

/* outranks the global .form-control rules; the input stays focusable so copy works */
.mbr-discount__code-value {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  padding: 0;
  background: none;
  border: 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.12em;
  color: var(--mbr-color-primary);
  text-align: left;
}

.mbr-discount__code-value:focus {
  outline: none;
}

.mbr-discount__copy {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-tint);
  border: 0;
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-primary);
  transition: transform 0.12s ease;
}

.mbr-discount__copy:active {
  transform: scale(0.95);
}

.mbr-discount__copy svg {
  width: 18px;
  height: 18px;
}

.mbr-discount__hint {
  margin: 12px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-discount__heading {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: normal;
  color: var(--mbr-color-ink-headline);
}

.mbr-discount__rows {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 14px;
}

.mbr-discount__row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.mbr-discount__row p {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 19px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-discount__icon {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: var(--mbr-color-peach);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-positive);
}

.mbr-discount__icon svg {
  width: 14px;
  height: 14px;
}

.mbr-discount__terms {
  margin: 12px 0 0;
  padding: 12px 0 0 18px;
  border-top: 1px solid var(--mbr-color-tint-dark);
  list-style: disc;
}

.mbr-discount__terms li {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-discount__terms li:first-child {
  margin-top: 0;
}

/* Bottom-sheet positioning (only the rules this sheet uses) */
.modal.modal-bottom .modal-dialog {
  position: fixed;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: auto;
  transform: translate3d(0%, 0, 0);
}

.modal.modal-bottom .modal-content {
  height: auto;
  overflow-y: auto;
  border: none;
  border-radius: 0;
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}
</style>
